import { Button } from '@artosera/ui';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { appliquerMiseAJour, useMiseAJourDisponible } from '../../horsLigne/serviceWorker.js';
import styles from './BandeauHorsLigne.module.css';

export function BandeauMiseAJour(): JSX.Element | null {
  const { t } = useTranslation('regie');
  if (!useMiseAJourDisponible()) return null;
  return (
    <div className={styles.bandeau} role="status">
      <span className={styles.texte}>{t('horsLigne.miseAJour')}</span>
      <Button size="sm" onClick={appliquerMiseAJour}>
        {t('horsLigne.recharger')}
      </Button>
    </div>
  );
}
